module.exports = __webpack_public_path__ + "static/media/diagnosticos.e8db7498.jpg";